import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Paginator } from '@app/classes';
import { Platform } from '@app/classes/platform.class';
import { DeprecatedConfirmationDialogComponent } from '@app/components';
import { CompanyMenuService } from '@app/modules/company/services';
import { AuthService } from '@app/services/auth.service';
import { NotifyService } from '@app/services/notify.service';
import { ShowView } from '@common/views';
import { Company } from '@models/company/company.model';
import { Office } from '@models/company/office.model';
import { Employee } from '@models/employee/employee.model';

@Component({
    templateUrl: './office-show.template.html',
    styleUrls: ['./office-show.style.scss'],
})
export class OfficeShowView extends ShowView implements OnInit {
    @ViewChild('confirmDeleteDialog', { static: true }) confirmDeleteDialog: DeprecatedConfirmationDialogComponent;
    isLoading = true;
    editPermission: string[] = Office.permission.edit;
    viewPeoplePermission: string[] = Platform.people.directory.permission.view;
    office: Office;
    _googleImage = '';
    paginator: Paginator;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private notify: NotifyService,
        private auth: AuthService,
        public companyMenuService: CompanyMenuService
    ) {
        super();
        this.office = this.route.snapshot.data.models.get('office');
        Company.find(this.auth.company.id).then((company) => {
            this.office.isPrimary = this.office.id === company.primaryAddressId;
        });
        this.paginator = new Paginator(
            Employee.param('company', this.auth.company.id)
                .with(['account', 'department', 'job'])
                .where('officeId', this.office.id),
            { shouldAutoLoadData: true }
        );

        this.paginator.onLoading((isLoading) => {
            this.isLoading = isLoading;
        });
    }

    ngOnInit(): void {
        this.buildGoogleImageUrl();
    }

    async onSave(): Promise<void> {
        if (!this.office.isDirty()) {
            return;
        }

        this.isLoading = true;

        try {
            await this.office.param('company', this.auth.company.id).save();
            this.notify.success('company.office.officeSaveSuccessMessage');
        } catch (error) {
            this.notify.error(error.message || 'company.office.officeSaveErrorMessage');
        } finally {
            this.isLoading = false;
        }
    }

    onCancel(): void {
        this.office.revert();
    }

    getGoogleMapsImage(): string {
        return this._googleImage;
    }

    async onDelete(): Promise<void> {
        const confirm = await this.confirmDeleteDialog.show();

        if (!confirm) {
            return;
        }

        try {
            await this.office.delete();
            this.notify.success('company.office.officeDeleteSuccessMessage');
            this.router.navigate(['../'], { relativeTo: this.route });
        } catch (error) {
            this.notify.error(error.message || 'company.office.officeDeleteErrorMessage');
        }
    }

    private buildGoogleImageUrl(): void {
        setTimeout(() => {
            let src = 'https://maps.googleapis.com/maps/api/staticmap?markers=color:blue%7C';
            src += `${this.office.addressLine1}, ${this.office.city}, ${this.office.country}`;
            src += '&scale=2&zoom=13&size=1400x250';
            src += '&maptype=roadmap&key=AIzaSyA54StRlp_plgojz590qzCas8maj5RIkMc';
            this._googleImage = src;
        });
    }
}
